module.exports = __webpack_public_path__ + "img/logo.c43d29e1.png";